import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedResidentDiscount } from './ResidentDiscount';
import { ResidentDiscountCheckbox } from './ResidentDiscountCheckbox';
import { ResidentDiscountMessageDesktop } from './ResidentDiscountMessageDesktop';
import { ABUtils } from '../../utils';

const getComponent = ({ checked, hasNonAdults, onChange, regionsText }) => {
    const { isResidentDiscount, isResidentDiscountPaxType } = ABUtils.getABs();

    return isResidentDiscount ?
        (
            <ResidentDiscountMessageDesktop
                hasNonAdults={hasNonAdults}
                regionsText={regionsText}
                isResidentDiscountPaxType={isResidentDiscountPaxType}
            />
        ) :
        (
            <ResidentDiscountCheckbox
                checked={checked}
                hasNonAdults={hasNonAdults}
                onChange={onChange}
                regionsText={regionsText}
                showInfo
            />
        );
};

getComponent.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    hasNonAdults: PropTypes.bool.isRequired,
    regionsText: PropTypes.string.isRequired,
};

export const ResidentDiscount = () => {
    return (
        <ConnectedResidentDiscount>
            {({ checked, hasNonAdults, hasRegions, onChange, regionsText }) => (
                <React.Fragment>
                    {hasRegions && (
                        <div className='odf-space-inner-bottom-s'>
                            {getComponent({ checked, hasNonAdults, onChange, regionsText })}
                        </div>
                    )}
                </React.Fragment>
            )}
        </ConnectedResidentDiscount>
    );
};
